// src/component/section/membersection.js

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import MemberItem from "../items/memberitem";
import MemberItemTwo from "../items/memberitemtwo";

const title = "New Members in HotAdultHub";
const subtitle = "Meet New People Today!";

const MemberSection = () => {
  const [members, setMembers] = useState([]);

  useEffect(() => {
  const fetchLatestUsers = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/latest-users`
      );
      console.log("Latest Users:", response.data);
      setMembers(response.data);
    } catch (error) {
      console.error("Failed to fetch latest users:", error);
    }
  };

  fetchLatestUsers();
}, []);


  return (
    <section className="member-section padding-tb">
      <div className="container">
        <div className="section-header">
          <h4 className="theme-color">{subtitle}</h4>
          <h2>{title}</h2>
        </div>
        <div className="section-wrapper">
          <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-center">
            <MemberItem members={members} />
          </div>
          
          <div className="member-button-group d-flex flex-wrap justify-content-center">
            <Link to="/members" className="lab-btn">
              <i className="icofont-users"></i> <span>Show More </span>
            </Link>
            {/* <Link to="/login" className="lab-btn">
              <i className="icofont-play-alt-1"></i>
              <span>Our TV Commercial</span>
            </Link> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MemberSection;
